import React, { useState } from 'react'
import AddCustomerModal from './AddCustomerModal'

function OnboardingTab({ role }) {
  const [showModal, setShowModal] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [customerType, setCustomerType] = useState(null)

  const handleAddCustomer = () => {
    setShowModal(true)
  }

  const handleSelectType = (type) => {
    setCustomerType(type)
    setShowModal(false)
    setShowForm(true)
    console.log(`Opening ${type} form`)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setCustomerType(null)
  }

  // If form is showing, render it
  if (showForm) {
    return (
      <div style={{ padding: '20px' }}>
        <button
          onClick={handleCloseForm}
          style={{
            marginBottom: '20px',
            padding: '8px 16px',
            backgroundColor: '#666',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          ← Back to Onboarding
        </button>
        
        <div style={{
          padding: '40px',
          backgroundColor: 'white',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>
            {customerType === 'individual' ? 'Individual KYC Form' : 'Corporate KYB Form'}
          </h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            Form will be built in next step
          </p>
          <p style={{ color: '#0d47a1', fontWeight: 'bold' }}>
            Selected Type: {customerType}
          </p>
        </div>
      </div>
    )
  }

  // Main onboarding tab view
  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#0d47a1',
        marginBottom: '20px'
      }}>
        Customer Onboarding
      </h2>

      {/* Add Customer Button */}
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}>
        <h3 style={{ fontSize: '18px', marginBottom: '15px', color: '#333' }}>
          Start New Onboarding
        </h3>
        <button
          onClick={handleAddCustomer}
          style={{
            backgroundColor: '#0d47a1',
            color: 'white',
            border: 'none',
            padding: '14px 28px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          + Add Customer
        </button>
      </div>

      {/* Customers List */}
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '20px',
          color: '#333'
        }}>
          Recent Customers (0)
        </h3>

        <p style={{
          color: '#999',
          fontStyle: 'italic',
          textAlign: 'center',
          padding: '40px 0'
        }}>
          No customers yet. Click "Add Customer" to get started.
        </p>
      </div>

      {/* Modal */}
      <AddCustomerModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSelectType={handleSelectType}
      />
    </div>
  )
}

export default OnboardingTab